import $ from "jquery";
import { Klass, u_, csl } from "@pressmedia/webappbase";
import vuwer from "@pressmedia/vuwer";

/**
 * VuwField (extends VuwerComponent)
 * - base Vuw of input fieldset
 * @options
 * - @required {String} inpType
 * - @required {String} paramKey
 * - {Array} inpClassList
 * - {Function} getInpReady
 * - {String} idPrefix
 * - {mixed} default
 */
vuwer.appendKlass("VuwField", {
	inpType: "",					// required
	paramKey: "",					// required
	default: undefined,
	
	_initialize: function _initialize(opt) {
		if( !u_.isObject(opt) || !opt.paramKey || !u_.isString(opt.paramKey) ) {
			csl.warn.red( (this.getAddress() || "VuwField") + "._initialize() ... arguments error.");
			return false;
		}
		
		if( Klass("VuwField").parent._initialize.call(this, opt) ) {
			if(!this.inpType) {
				csl.warn.red(this.getAddress() + "._initialize() ... no inpType.");
				return false;
			}
			
			this.$inp = {
				length: 0
			};
			
			// [入力部品のクラス]
			this.inpClassList = Array.isArray(this.inpClassList) ? [].concat(this.inpClassList) : [];
			
			// [データの入力制限]
			if( this.hasOwnProperty("ltd") &&
					(!u_.isNumber(this.ltd) || this.ltd <= 0) ) {
				delete this.ltd;
			}
			
			// [エラーメッセージ格納領域]
			this.errorMessages = {};
			// [バリデーション関数格納領域]
			this._validations = {};
			
			// [id用の文字列]
			this.idStr = this.paramKey;
			// idPrefixが設定されていない場合は親formから取得
			( !this.idPrefix || !u_.isString(this.idPrefix) ) && (function(fm) {
				!!fm && (this.idPrefix = fm.inputIdPrefix || "");
			}).call( this, this.getForm() );
			// idStrの前にprefixを記述
			if( this.idPrefix && u_.isString(this.idPrefix) ) {
				this.idStr = this.idPrefix + "_" + this.idStr;
			}
			
			return this;
		} else {
			return false;
		}
	},
	
	addValidation: function addValidation(valiKey, fn, message) {
		if( !u_.isString(valiKey) || !u_.isFunction(fn) || !u_.isString(message) ) {
			csl.warn.red(this.getAddress() + ".addValidation() ... arguments error.");
			return this;
		}
		
		this._validations[valiKey] = fn;
		this.errorMessages[valiKey] = message;
		return this;
	},
	
	showPrompt: function showPrompt(valiKey) {
		if( !u_.isString(valiKey) || !u_.isString(this.errorMessages[valiKey]) ) {
			csl.warn.red(this.getAddress() + ".showPrompt() ... arguments error.");
			return this;
		}
		
		this.$self.addClass("is-error").attr("title", this.errorMessages[valiKey])
		.on("change.refresh", function(e, isTrigger) {
			$(this).removeClass("is-error").attr("title", "").off(".refresh");
		});
		
		csl.log.red("**** validate error", {
			paramKey: this.paramKey,
			msg: this.errorMessages[valiKey]
		});
		return this;
	},
	
	validate: function validate() {
		var
			val = this.getVal(),
			keys = Object.keys(this._validations),
			l = keys.length,
			i;
		
		if( this.$self.hasClass("is-error") ) {
			this.$self.removeClass("is-error").attr("title", "").off(".refresh");
		}
		
		for(i = 0; i < l; i++) {
			if(this._validations[ keys[i] ].call(this, val) === false) {
				this.showPrompt(keys[i]);
				return false;
			}
		}
		
		return true;
	},
	
	setVal: function setVal(value) {
		// _valueに値をセット
		this._value = value;
		return this;
	},
	
	getVal: function getVal() {
		// setVal()でセットされた_value値を返す
		return this._value;
	},
	
	clearVal: function clearVal() {
		// setValに第２引数以降が存在する子Klass用に、argumentsを渡す仕様とする
		var args = u_.getAsArray(arguments);
		args.unshift(this.default);
		return this.setVal.apply(this, args);
	},
	
	getCopiedElement: function getCopiedElement() {
		var $clone, arr;
		if(this.$self) {
			$clone = this.$self.clone();
			$clone.attr("id", $clone.get(0).id + "_copied").empty();
			arr = this._getCopiedInp();
			!!arr.length && $.fn.append.apply($clone, arr);
		}
		return $clone;
	},
	
	_getCopiedInp: function _getCopiedInp(val) {
		var clones = [];
		
		(val === undefined) && ( val = this.getVal() );
		
		if( (u_.isString(val) && val) || u_.isNumber(val) ) {
			clones.push( $("<span/>").addClass("replaced-inp").text(val) );
		} else
		if( Array.isArray(val) ) {
			val.forEach(function(v) {
				clones = clones.concat( this._getCopiedInp(v) );
			}, this);
		}
		return clones;
	},
	
	getForm: function getForm() {
		if(this.container) {
			if( this.container instanceof Klass("VuwForm") ) {
				return this.container;
			} else {
				return Klass("VuwField").prototype.getForm.call(this.container);
			}
		} else {
			return false;
		}
	},
	
	renderField: function renderField() {
		var renderedElm;
		
		if(!this.$self) {
			return this;
		}
		
		renderedElm = this._renderField();
		if(renderedElm) {
			// _renderField()の戻り値でDOM要素を更新
			if( !(renderedElm instanceof $) &&
					( u_.isElement(renderedElm) || u_.isString(renderedElm) ) ) {
				renderedElm = $(renderedElm);
			}
			
			if(renderedElm instanceof $ && renderedElm.length) {
				this.$self.replaceWith(renderedElm);
				this.$self = renderedElm;
				$.data(this.$self.get(0), "vuw", this);
				u_.isFunction(this.getInpReady) && this.getInpReady(this.$self);
			}
		}
		
		return this;
	},
	
	_renderField: function _renderField() {
		// abstract function
		throw new Error("Not Implemented.");
	}
}, "VuwerComponent");
